import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ErrorMessages} from '../../../shared/common/errormessages';
import {validationmethod} from '../../../shared/common/validationmethod';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FormFieldsTrimer} from '../../../shared/Validations/FormFieldsTrimer';
import {ReporttemplateService} from '../../../shared/services/reporttemplate.service';
import {LocalStorageSettingsService} from '../../../shared/services/local-storage-settings.service';
import {ReportlinksserviceService} from '../../reportlinks/reportlinksservice.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {constants} from '../../../shared/common/contants';
import {CommonService} from '../../../shared/services/common.service';
import {TemplateReportService} from '../../../shared/services/template-report.service';
import {lastValueFrom, tap} from 'rxjs';
import {getXHRResponse} from 'rxjs/internal/ajax/getXHRResponse';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';

export interface FormData {
  edata: any;
}

@Component({
    selector: 'app-report-template-popup',
    templateUrl: './template-report-popup.component.html',
    styleUrls: ['./template-report-popup.component.scss'],
    standalone: false
})
export class TemplateReportPopupComponent implements OnInit {
  backgroundColorButton;
    reportOutputFormat: string = '';
  reportOutputTypes: any = [];

  templatecreationmaster: FormGroup;
  templateCreationData = {
    'reportTemplateId': null,
    'reportTemplateName': null,
    'reportTemplateDescription': null,
    'reportType': null,
    'vaultBinderTemplate': null,
    'scheduleId': null,
    'templateType': null,
    'quickSightReference': null,
    'parentTemplateId': null,
    'datasetId': null,
    'templateFileName': null,
    'templateFile': null,
    'binderDocType': null,
    'binderDocSubType': null,
    'binderDocClassification': null,
    'binderSectionName': null,
    'dnsId': null,
    'status':'Yes',
    'templateFilePath':null,
    'configfilepath':null,
    'documentDocTypeLabel':null,
    'documentDocSubTypeLabel':null,
    'documentDocClassificationLabel':null,
    'manageFiltersIds':[],
    'reportAccessType':null,
    'report_rolesIds':null,

    'report_ownerRoleid':null,

    "docLifecycle": null,



   // 'report_ownerRoleid': null,
    'configFileName':null,
    'configFile':null,
    'binderType':null,
    'mergeReports':null,
      'reportOutputFormat': null


  };
  reportTemplateDescription;
  reportTypedropdown;
  vaultBinderTemplateDropDown;
  datasetDropDown;
  datasetloop;
  templateTypeDropDown;
  imagephoto;
  imagephotoshow: any = false;
  imagephoto2;
  imagephotoshow2: any = false;
  parentTemplateDropDown;
  templatefiletype;
  reportTypeName;
  templateTypeName;
  selectionDropDown: any = [];
  buttonName;
  docTypeDropDown;

  docLifecycleDropdown;
  docSubTypeDropDown: any = [];
  docClassificationDropDown: any = [];
  showCliassification: boolean = false;
  docSubTypeShow: boolean = false;
  pushToVault=false;

  getDataSourceDetails;
  validation_messages;
  selectfilter:any=[];
  selectDataset:any=[];
  filterstable: any = [];

  binderTypes = [
    {
      "name" : "s3",
      "label" : "S3"
    },
    {
      "name" : "vault",
      "label" : "Vault"
    }
  ];

  mergeReports = [
    {
      "name" : "No",
      "label" : "No"
    },
    {
      "name" : "Yes",
      "label" : "Yes"
    }
  ];

  parentTemplateType = 's3';

  constructor(private dialogref: MatDialogRef<TemplateReportPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public data: FormData,
              private errormessages: ErrorMessages,
              private validation: validationmethod,
              private spinner: NgxUiLoaderService,
              private fb: UntypedFormBuilder,
              private formFieldsTrimer: FormFieldsTrimer,
              private constants: constants,
              private service: TemplateReportService,
              private localStorageSettings: LocalStorageSettingsService,
              private commonService: CommonService,
              private snackbar: MatSnackBar,
              private reportingService: ReportingServiceService,
              private linkservice: ReportlinksserviceService,
              private reportService: ReporttemplateService ) {
              this.validation_messages = this.errormessages.retportTemplatecreationmaster;

  }

 async ngOnInit() {
    this.formValidation();
    this.spinner.start();
    this.templateCreationData.dnsId = this.localStorageSettings.getSettings('dnsName');
    this.templateCreationData.mergeReports = this.mergeReports[0].name;
    this.templatecreationmaster.controls['mergeReports'].setValue(this.templateCreationData.mergeReports);
    this.buttonName = 'Save';
    console.log(this.data);
    this.retrieveDataSourceSingleRecord(this.templateCreationData.dnsId);
    // await this.retrieveDataSourceSingleRecord(this.templateCreationData.dnsId)
    console.log(this.templateCreationData);
    this.commonService.getlookupVauleByLookUpType('Vault Report Type').subscribe(response => {

      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});


      } else {

        this.spinner.stop();
        console.log(response);
        this.reportTypedropdown = response;
        this.reportTypedropdown.forEach(obj => {
          console.log(obj);
          this.templatecreationmaster.controls['reportType'].setValue(this.templateCreationData.reportType);
          if (obj.lookupvalueid == this.templateCreationData.reportType) {
            this.reportTypeName = obj.lookupcode;
          }
        });
        this.editDataUpdate();
      }
    });
   this.commonService.getlookupVauleByLookUpType('DataSetOutputFormat').subscribe(response => {
    console.log('Report Output Formats:', response);
    if (response.error == true) {
      this.spinner.stop();
      this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
    } else {
      this.spinner.stop();
      console.log(response);
      this.reportOutputTypes = response; // Assign directly like reportTypedropdown
      // Set default value if needed for edit mode
      if (this.data.edata && this.data.edata.reportOutputFormat) {
        this.templatecreationmaster.controls['reportOutputFormat'].setValue(this.data.edata.reportOutputFormat);
        this.reportOutputFormat = this.data.edata.reportOutputFormat;
      }
    }
  });
    
    if (this.data.edata) {
      console.log(this.data.edata);
      console.log("---"+this.data.edata.report_ownerRoleid+"----"+this.data.edata.report_rolesIds+"--"+this.data.edata.reportAccessType);
      this.buttonName = 'Update';
      //   this.templateCreationData = this.data.edata
      this.templateCreationData = {
        'reportTemplateId': this.data.edata.reportTemplateId,
        'reportTemplateName': this.data.edata.reportTemplateName,
        'reportTemplateDescription': this.data.edata.reportTemplateDescription,
        'reportType': Number(this.data.edata.reportType),
        'vaultBinderTemplate': this.data.edata.vaultBinderTemplate,
        'scheduleId': Number(this.data.edata.scheduleId),
        'templateType': Number(this.data.edata.templateType),
        'quickSightReference': this.data.edata.quickSightReference,
        'parentTemplateId': Number(this.data.edata.parentTemplateId),
        'datasetId': Number(this.data.edata.datasetId),
        'templateFileName': this.data.edata.templateFileName,
        'templateFile': '',
        'binderDocType': this.data.edata.binderDocType,
        'binderDocSubType': this.data.edata.binderDocSubType,
        'binderDocClassification': this.data.edata.binderDocSubType,
        'binderSectionName': this.data.edata.binderSectionName,
        'dnsId': this.data.edata.dnsId,
        'status':this.data.edata.status,
        'templateFilePath':this.data.edata.templateFilePath,
        'configfilepath':this.data.edata.configfilepath,
        'documentDocTypeLabel':this.data.edata.documentDocTypeLabel,
        'documentDocSubTypeLabel':this.data.edata.documentDocSubTypeLabel,
        'documentDocClassificationLabel':this.data.edata.documentDocClassificationLabel,
        'manageFiltersIds':this.data.edata.manageFiltersIds,
        'reportAccessType':this.data.edata.reportAccessType,
        'report_rolesIds':this.data.edata.report_rolesIds,
        'docLifecycle': this.data.edata.docLifecycle,
        'report_ownerRoleid': this.data.edata.report_ownerRoleid,
        'configFileName': this.data.edata.configFileName,
        'configFile': this.data.edata.configFile,
        'binderType': this.data.edata.binderType,
        'mergeReports': this.data.edata.mergeReports,
        'reportOutputFormat': this.data.edata.reportOutputFormat, // Add this

      };
      this.templatecreationmaster.controls['reportType'].setValue(this.data.edata.reportType);
  this.templatecreationmaster.controls['reportOutputFormat'].setValue(this.data.edata.reportOutputFormat);
  this.reportOutputFormat = this.data.edata.reportOutputFormat;

      this.templatecreationmaster.get('reportType').disable();
      this.selectDataset=this.data.edata.dataSetName;
      console.log("datasetid=> "+this.data.edata.datasetId)
      if(this.data.edata.datasetId!=null&&this.data.edata.datasetId!=""){
        console.log(this.data.edata.datasetId)
        if(this.data.edata.manageFiltersIds!=null && this.data.edata.manageFiltersIds!=""){
          this.selectfilter = this.data.edata.manageFiltersIds.split(",").map(id => Number(id));
          console.log(this.selectfilter);
          // this.selectfilter=[45]
        }
        // this.selectfilter=36
        console.log(this.data.edata.manageFiltersIds);

      }
      this.retriveManageFilters(this.data.edata.datasetId)
   }
   if (this.templateCreationData.documentDocSubTypeLabel == null) {
     this.docSubTypeShow = false;
     this.templatecreationmaster.get('documentDocSubTypeLabel').setValidators([]);
     console.log("inside if 250")

   } else {
     this.docSubTypeShow = true;
     console.log("inside else 252")

     //this.templatecreationmaster.get('documentDocSubTypeLabel').setValidators([]);
   }
   if (this.templateCreationData.documentDocClassificationLabel == null) {
     this.showCliassification = false;
     this.templatecreationmaster.get('documentDocClassificationLabel').setValidators([]);
     console.log("inside if 261")

   } else {
     this.showCliassification = true;
     console.log("inside else 259")
     //this.templatecreationmaster.get('documentDocClassificationLabel').setValidators([]);
   }
   this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
   //this.templatecreationmaster.get('documentDocClassificationLabel').enable();
  }

  formValidation() {
    this.templatecreationmaster = new FormGroup({
      reportTemplateName: new FormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator, Validators.maxLength(100)]),
      reportTemplateDescription: new FormControl('', [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100)]),
      reportType: new FormControl('', [Validators.required]),
      vaultBinderTemplate: new FormControl('', [Validators.required]),
      parentTemplateId: new FormControl('', [Validators.required]),
      binderSectionName: new FormControl('',),
      datasetId: new FormControl('', [Validators.required]),
      templateType: new FormControl('', [Validators.required]),
      templateFile: new FormControl('', [Validators.required]),
      quickSightReference: new FormControl('', [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100)]),
      documentDocTypeLabel:new FormControl('', [Validators.required]),
      documentDocSubTypeLabel: new FormControl('',[]),
      documentDocClassificationLabel: new FormControl('',[]),     
      documentDocLifecycle: new FormControl('', [Validators.required]),
      docLifecycleName: new FormControl('', []),
      selectfilter: new FormControl('', []),
      configFile: new FormControl('', []),
      binderType: new FormControl('', [Validators.required]), 
      mergeReports: new FormControl('', [Validators.required]),
      reportOutputFormat: new FormControl('', [Validators.required]) // Add this
    });
  }

  cancel() {
    this.dialogref.close();
  }
  //save and updating the template report data in db
 
  save() {
    console.log(this.templateCreationData);
    console.log(this.templatecreationmaster);
    if (!this.templatecreationmaster.valid) {
      // displaying validation messages
      this.validation.getvalidationmessage();
      this.validation.validateAllFormFields(this.templatecreationmaster);
      
      return;
    } else {
        this.templateCreationData.reportOutputFormat = this.reportOutputFormat;

        this.templateCreationData.manageFiltersIds=this.selectfilter.join(",")


      this.spinner.start();
      this.service.insertUpdateReportTemplate(this.templateCreationData).subscribe(response => {
        if (response.error == true) {

          this.spinner.stop();
          const stringArray = response.statusMessage.split('.');
          const lineone = stringArray[0].trim();
          const res = lineone +" "+stringArray[1].trim();
          this.snackbar.open(res, 'OK', {duration: 5000, panelClass: ['alert-red']}, );


        } else {

          this.spinner.stop();
          this.dialogref.close();
          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});


        }
      });
    }

  }

//select of vaultbindertemplate give values to docType,docsubType and docClassfication from drowpdown value
  VaultbindSelect(value: any) {
    this.vaultBinderTemplateDropDown.forEach(obj => {
      if (obj.name__v == value) {
        this.templateCreationData.binderDocType = obj.type__v;
        this.templateCreationData.binderDocSubType = obj.subtype__v;
        this.templateCreationData.binderDocClassification = obj.classification__v;
      }

    });


  }

  templateTypeSelect(event: any) {

    this.templateTypeDropDown.forEach(obj => {
      if (obj.lookupvalueid == event.value) {
        this.templateTypeName = obj.lookupcode;
      }

    });

      /*
      * Modified by Renuka chama
      * 06/08/2025
      * The code has been updated to include a condition that displays the field value only when it is present.
      */
    if (!this.templateCreationData.templateFileName) {
    this.templateCreationData.templateFileName = null;
    this.templateCreationData.templateFile = null;
  }
  if (!this.templateCreationData.configFileName) {
    this.templateCreationData.configFile = null;
    this.templateCreationData.configFileName = null;
  } 
    console.log(this.templateTypeName+"=========================")
    /**
     * Modified By Ashwin M
     * 25/08/2025
     * code modified to enable and/or disable required fields based on templateTypeName
     */
    if (this.templateTypeName == 'Document') {
      this.templatecreationmaster.get("configFile").enable();
      this.templatecreationmaster.get('templateFile').enable();
      this.templatecreationmaster.get('quickSightReference').disable();
    } else if (this.templateTypeName === 'QS') {
      this.templatecreationmaster.get('templateFile').disable();
      this.templatecreationmaster.get("configFile").disable();
      this.templatecreationmaster.get('quickSightReference').enable();
    } else {
      this.templatecreationmaster.get('templateFile').enable();
      this.templatecreationmaster.get("configFile").disable();
      this.templatecreationmaster.get('quickSightReference').disable();
    }
    this.templatecreationmaster.get("configFile").reset();
    // this.templatecreationmaster.get('templateFile').reset();
    this.templatecreationmaster.get('quickSightReference').reset();
  }



  reportType(value) {
    this.templateCreationData.reportType = value;
    this.reportTypedropdown.forEach(obj => {
      if (obj.lookupvalueid == value) {
        this.reportTypeName = obj.lookupcode;
        console.log(this.reportTypeName);
      }
    });
    this.reteriveDataOnReportType();
    console.log(value+"=====================================  ")
    this.showCliassification = false;
    this.docSubTypeShow = false;
  }

  uploadFile($event: Event) {
    const input = $event.target as HTMLInputElement;
    const file: File = input.files[0];
    console.log(this.templateTypeName)
    if ( this.templateTypeName ==="Document") {
      this.readThisDoc($event.target);
    } else {
      this.readThisimage($event.target);
    }
   
    

  }

  readThisimage(inputValue: any,): void {
    let ischeckfile = false;
    let filecheck;
    var file: File = inputValue.files[0];
    console.log(file)
    var FileS: File = inputValue.files[0];
    if (this.templateTypeName == 'PDF') {
      filecheck = 'application/pdf';
    } else {
      filecheck = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    if (filecheck === file.type) {

      if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/pdf') {

        ischeckfile = true;
      }
    }
    if (ischeckfile) {

      var size = file.size / 1000;
      if (size <= 25072) {
        var fileName = FileS.name;
        //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

        var photo: FileReader = new FileReader();
        photo.onloadend = e => {
          var img = photo.result;
          var photobase64result = photo.result.toString().split(',', 2)[1];

          // this is to check the file is empty or not
          this.imagephoto = photo.result.toString();
          this.imagephotoshow = true;
          this.templateCreationData.templateFile = photobase64result;
          this.templateCreationData.templateFileName = fileName;
          // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

        };
        photo.readAsDataURL(file);
      } else {
        this.snackbar.open('Selected image ' + file.name + ', size should be less than 3MB', 'OK', {
          duration: 5000,
        });
      }
    } else {
      if (this.templateTypeName == 'PDF') {
        this.snackbar.open(file.name + ' is invalid file. Please select PDF file ', 'OK', {
          duration: 5000,
        });
      } else {
        this.snackbar.open(file.name + ' is invalid file. Please select EXCEL file ', 'OK', {
          duration: 5000,
        });
      }

    }
  }
  // ===============================
  readThisDoc(inputValue: any,): void {
    let ischeckfile = false;
    let filecheck;
    var file: File = inputValue.files[0];
    console.log(file)
    var FileS: File = inputValue.files[0];
    console.log(this.templateTypeName)
    if (this.templateTypeName == 'Document') {
      filecheck = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } 
    if (filecheck === file.type) {

      if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {

        ischeckfile = true;
      }
    }
    if (ischeckfile) {

      var size = file.size / 1000;
      if (size <= 25072) {
        var fileName = FileS.name;
        //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

        var photo: FileReader = new FileReader();
        photo.onloadend = e => {
          var img = photo.result;
          var photobase64result = photo.result.toString().split(',', 2)[1];

          // this is to check the file is empty or not
          this.imagephoto = photo.result.toString();
          this.imagephotoshow = true;
          this.templateCreationData.templateFile = photobase64result;
          this.templateCreationData.templateFileName = fileName;
          // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

        };
        photo.readAsDataURL(file);
      } else {
        this.snackbar.open('Selected File ' + file.name + ', size should be less than 3MB', 'OK', {
          duration: 5000,
        });
      }
    } else {
        this.snackbar.open(file.name + ' is invalid file. Please select Doc file ', 'OK', {
          duration: 5000,
        });
      

    }
  }

  uploadConfigFile($event: Event) {
  
    this.uploadConfigFileToS3($event.target);
  }
  uploadConfigFileToS3(inputValue: any,): void {
    let ischeckfile = false;
    let filecheck;
    var file: File = inputValue.files[0];
    console.log(file)
    var FileS: File = inputValue.files[0];
    console.log(this.templateTypeName)
    if (this.templateTypeName == 'Document') {
      filecheck = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    if (filecheck === file.type) {

      if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {

        ischeckfile = true;
      }
    }
    if (ischeckfile) {

      var size = file.size / 1000;
      if (size <= 25072) {
        var fileName = FileS.name;
        //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

        var photo: FileReader = new FileReader();
        photo.onloadend = e => {
          var img = photo.result;
          var photobase64result = photo.result.toString().split(',', 2)[1];

          // this is to check the file is empty or not
          this.imagephoto2 = photo.result.toString();
          this.imagephotoshow2 = true;
          this.templateCreationData.configFile = photobase64result;
          this.templateCreationData.configFileName = fileName;
          // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

        };
        photo.readAsDataURL(file);
        console.log(this.templateCreationData)
      } else {
        this.snackbar.open('Selected File ' + file.name + ', size should be less than 3MB', 'OK', {
          duration: 5000,
        });
      }
    } else {  
        this.snackbar.open(file.name + ' is invalid file. Please select EXCEL file ', 'OK', {
          duration: 5000,
        });
      

    }
  }


// ========================================
  SelectionSelect(value: any) {

    this.selectionDropDown.forEach(obj => {

      if (value == obj.id) {
        this.templateCreationData.binderSectionName = obj.label__v;
      }
    });

  }

  selectParentTemplate(value) {
    let dnsId = this.localStorageSettings.getSettings('dnsName');
    let vaultBinderTemplate;
    let parentObject = null;
    this.parentTemplateDropDown.forEach(obj => {
      if (value == obj.reportTemplateId) {
        console.log(obj);
        parentObject = obj;
        vaultBinderTemplate = obj.vaultBinderTemplate;
        this.parentTemplateType = obj.binderType;
        //Modified by Bhor S, 30-06-25
      //updating bindertype in template creation data
        this.templateCreationData.binderType= obj.binderType;
        this.templateCreationData.binderDocType = obj['binderDocType']
        this.templateCreationData.binderDocSubType = obj['binderDocSubType']
        this.templateCreationData.binderDocClassification = obj['binderDocClassification']
        this.templateCreationData.vaultBinderTemplate = obj.vaultBinderTemplate
      }
    });
    if (this.parentTemplateType == 'vault' && this.pushToVault){
      this.spinner.start();
      this.service.retrieveVaultBinderTemplateSections(dnsId, vaultBinderTemplate).subscribe(response => {
        if (response.error == true) {

          this.spinner.stop();

          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});


        } else {

          this.spinner.stop();
          console.log(response);
          this.selectionDropDown = response;


        }
      });
      //Modified by Bhor S, 13-07-25
      //made this method call to retrieve document metadata details
      this.reteriveDataOnReportType();
    } else {
      this.spinner.start();
      this.templateCreationData.datasetId = parentObject.datasetId;
      this.templatecreationmaster.controls['datasetId'].setValue(parentObject.datasetId);
      this.retriveManageFilters(parentObject.datasetId);
      //Modified by Bhor S, 30-06-25
      //calling method to retrieve dataset details and others in case templatetype is s3
      this.reteriveDataOnReportType();
      this.spinner.stop();
    }

  }
/* @added By Ravi G
   @Date 21/02/2023
   @desc reteriveDataOnReportType() call when update the service and select template type
     if reporttypename equalsto 'RB'(Report Binder) retrieve VaultBinder Templates else retrieve dataset,Template Type
    and disable the field which are used in 'SA'(Stand Alone) and 'SR'(Sub Report drop down) if reporttypename equalsto 'SR'
    retrieve parentTemplate on the base of parentreporttemplate download section
* */
 async reteriveDataOnReportType() {
  console.log(this.reportTypeName)
  console.log(this.templateCreationData.binderType)
    if (this.reportTypeName == 'RB') {
      if (this.pushToVault && this.templateCreationData.binderType=='vault'){
        this.spinner.start();
        this.service.retrieveVaultBinderTemplatesCollection().subscribe(response => {
          console.log(response);
          if (response.error == true) {
            this.spinner.stop();
            this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
          } else {
            this.spinner.stop();
            this.vaultBinderTemplateDropDown = response;
          }
        });
      } else {
        this.spinner.start();
        let colNameAndValues = 'tenantid=' + this.templateCreationData.dnsId;
        this.spinner.start();
        this.commonService.getlistByMultiplewhereclause('reportcreation', colNameAndValues).subscribe(response => {
          console.log(response);
          if (response.error == true) {
            this.spinner.stop();
            this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
          } else {
            this.spinner.stop();
            let responserequest;
            this.spinner.start();
            this.linkservice.fetchUserRoleAndName(this.localStorageSettings.getSettings("dnsName"),this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
            console.log(res);
            responserequest = res;
            this.datasetloop = response;
            this.datasetDropDown = [];
            let num =0;
            for (let i = 0; i < this.datasetloop.length; i++) {
              // console.log(this.datasetloop[i]); // Access each item in the array 
              if (this.datasetloop[i].dataset_ownerRoleid == responserequest.roleName || this.isRoleIdPresent(this.datasetloop[i].dataset_rolesIds, responserequest.roleId )|| this.datasetloop[i].datasetAccessType == "Public") {
                this.datasetDropDown[num++] = this.datasetloop[i];
            }
            }
            this.spinner.stop();
            console.log(this.datasetDropDown)
          });
        }
      });
        this.spinner.stop();
      }
    } else if (this.reportTypeName == 'SR' && this.parentTemplateType == 'vault' && !this.pushToVault){
        this.templatecreationmaster.controls['parentTemplateId'].setValue(null);
        this.snackbar.open("Please configure Target vault to create vault binder", 'OK', {duration: 5000})
        return;
    } else {
      if (this.reportTypeName == 'SA') {
        console.log("Check push to vault for SA");
        //Modified by Bhor S, 13-07-25
      //made this method  to await for this api call
        await this.retrieveDataSourceSingleRecord(this.templateCreationData.dnsId);
        if (this.pushToVault){
          this.parentTemplateType = 'vault'
        }
      }
      let colNameAndValues = 'tenantid=' + this.templateCreationData.dnsId;
      this.spinner.start();
      this.commonService.getlistByMultiplewhereclause('reportcreation', colNameAndValues).subscribe(response => {
        console.log(response);
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
        } else {
          this.spinner.stop();
          let responserequest;
          this.spinner.start();
          this.linkservice.fetchUserRoleAndName(this.localStorageSettings.getSettings("dnsName"),this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
          console.log(res);
          responserequest = res;
          this.datasetloop = response;
          this.datasetDropDown = [];
          let num =0;
          for (let i = 0; i < this.datasetloop.length; i++) {
            //console.log(this.datasetloop[i]); // Access each item in the array 
            if (this.datasetloop[i].dataset_ownerRoleid == responserequest.roleName || this.isRoleIdPresent(this.datasetloop[i].dataset_rolesIds, responserequest.roleId )|| this.datasetloop[i].datasetAccessType == "Public") {
              this.datasetDropDown[num++] = this.datasetloop[i];
            }
          }
          this.spinner.stop();
          console.log("Type Of: ",typeof this.templatecreationmaster.controls['datasetId'].value);
          if (!this.templatecreationmaster.controls['datasetId'].value) {
            this.templateCreationData.datasetId = this.data.edata.datasetId;
            this.templatecreationmaster.controls['datasetId'].setValue(
              Number(this.data.edata.datasetId)
            );
          }
          // this.templateCreationData.datasetId = this.data.edata.datasetId;
          // this.templatecreationmaster.controls['datasetId'].setValue(
          //   Number(this.data.edata.datasetId)
          // );
          this.templateCreationData.templateType = this.data.edata.templateType;
          this.templatecreationmaster.controls['templateType'].setValue(
            Number(this.data.edata.templateType)
          );

           /*
      * Modified by Renuka chama
      * 06/08/2025
      * code modified to Trigger the template type selection logic after setting the template type
      */
          this.templateTypeSelect({ value: this.templateCreationData.templateType })
          console.log(this.templatecreationmaster);
          console.log(this.datasetDropDown)
        });

        }
      });
      this.spinner.start();
      this.commonService.getlookupVauleByLookUpType('Template Type').subscribe(response => {
        console.log(response);
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
        } else {
          this.spinner.stop();
          this.templateTypeDropDown = response;
          console.log("Template type: ",this.templateCreationData.templateType);
          this.templateTypeDropDown.forEach(obj => {
            console.log(obj);
            this.templatecreationmaster.controls['reportType'].setValue(this.templateCreationData.reportType);
            if (obj.lookupvalueid == this.templateCreationData.templateType) {
              this.templateTypeName = obj.lookupcode;
              if (this.templateTypeName === 'QS') {
                this.templatecreationmaster.get('templateFile').disable();
                this.templatecreationmaster.get('quickSightReference').enable();
              } else {
                this.templatecreationmaster.get('templateFile').enable();
                this.templatecreationmaster.get('quickSightReference').disable();
              }
            }
          });
        }
      });
      if(this.parentTemplateType == 'vault'){
        this.service.retrieveAllVaultDocumentTypes().subscribe(async response => {
          if (response.error == true) {
            this.spinner.stop();
            this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
          } else {
            this.spinner.stop();
            this.docTypeDropDown = response;
            this.docLifecycleDropdown = this.docTypeDropDown.filter(a => a.docLifecycle != null);

            this.docTypeDropDown.forEach(res=>{
              if(res.docTypeLabel == this.templateCreationData.documentDocTypeLabel){
                this.docType = res.docType
              }
            })
            this.service.retrieveVaultDocumentSubTypes(this.docType).subscribe(response => {
              console.log(response);

              if (response.error == true) {

                this.spinner.stop();

                this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});

              } else {

                this.spinner.stop();
                this.docSubTypeDropDown = response;
                this.docLifecycleDropdown = this.docSubTypeDropDown.filter(a => a.docLifecycle != null);

                this.docSubTypeDropDown = this.docSubTypeDropDown.filter(a => a.docSubType != null);

                if (this.docSubTypeDropDown.length > 0) {
                  this.docSubTypeShow = true;
                  this.templatecreationmaster.get('documentDocSubTypeLabel').setValidators([Validators.required]);

                }
                this.docSubTypeDropDown.forEach(res=>{
                  if(res.docSubTypeLabel == this.templateCreationData.documentDocSubTypeLabel){
                    this.docSubType = res.docSubType
                  }
                  if (this.docType == undefined) {
                    this.showCliassification = false;
                    this.docSubTypeShow = false;
                  }
                })
                this.service.retrieveVaultDocumentClassifications(this.docType,this.docSubType).subscribe(response => {
                  console.log(response);

                  if (response.error == true) {

                    this.spinner.stop();

                    this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
                    return null

                  } else {
                    this.spinner.stop();
                 
                    this.docClassificationDropDown = response;
                    if (this.docSubTypeDropDown.length > 0) {
                      this.docLifecycleDropdown = this.docClassificationDropDown.filter(a => a.docLifecycle != null);

                    }

                    this.docClassificationDropDown = this.docClassificationDropDown.filter(a => a.docClassification != null);
                    if (this.docClassificationDropDown.length > 0) {
                      this.showCliassification = true;
                      this.templatecreationmaster.get('documentDocClassificationLabel').setValidators([Validators.required]);
                    }
                    console.log(this.docClassification);
                    console.log(this.templateCreationData)
                    this.docClassificationDropDown.forEach(res => {
                      if (res.docClassificationLabel == this.templateCreationData.documentDocClassificationLabel) {
                        this.docClassification = res.docClassification;
                      }
                    })
                    
                    this.service.retrieveVaultDocumentLifeCycleForClassifications(this.docType, this.docSubType, this.docClassification).subscribe(response => {
                      console.log(response);

                      if (response.error == true) {

                        this.spinner.stop();

                        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
                        return this.docLifecycleDropdown = null

                      } else {

                        this.spinner.stop();
                        if (this.docClassificationDropDown.length > 0) {
                          this.docLifecycleDropdown = response;

                        }
                        console.log(this.docLifecycleDropdown)
                        console.log(this.docLifecycleDropdown.length)
                        // if (this.docClassificationDropDown.length > 0) {
                        //   this.showCliassification = true;
                        // } else {
                        //   this.showCliassification = false;
                        // }
                        return this.docLifecycleDropdown;


                      }
                    });
                    //return this.docClassificationDropDown
                  }
                });



              }
            });


          }

        });
              }

    }
   console.log(this.reportTypeName, this.pushToVault, this.parentTemplateType);
   /**
     * Modified By Ashwin M
     * 25/08/2025
     * code modified to enable and disable required fields based on reportTypeName
     */
   if (this.reportTypeName == 'RB') {
      console.log("under RB")
      //disable and reset all the dropdown and textbox which are for SA and SR
      console.log(this.templateCreationData.binderType)
      if (this.pushToVault && this.templateCreationData.binderType=='vault'){
        console.log("Enable vault report form")
        this.templatecreationmaster.get('vaultBinderTemplate').enable();
        this.templatecreationmaster.get('mergeReports').disable();
        this.templatecreationmaster.get('datasetId').disable();
        this.templatecreationmaster.get('selectfilter').disable();
      } else {
        console.log("Enable s3 report form")
        this.templatecreationmaster.get('vaultBinderTemplate').disable();        
        this.templatecreationmaster.get('mergeReports').enable();
        this.templatecreationmaster.get('datasetId').reset();
        this.templatecreationmaster.get('selectfilter').reset();
        this.templatecreationmaster.get('datasetId').enable();
        this.templatecreationmaster.get('selectfilter').enable();
      }
      this.templatecreationmaster.get('binderType').enable();
      //Diable all other form fields related to Stand Alone Report or Sub Report
      this.templatecreationmaster.get('parentTemplateId').disable();
      this.templatecreationmaster.get('binderSectionName').disable();
      this.templatecreationmaster.get('documentDocTypeLabel').disable();
      this.templatecreationmaster.get('documentDocSubTypeLabel').disable();
      this.templatecreationmaster.get('documentDocClassificationLabel').disable();
      this.templatecreationmaster.get('documentDocLifecycle').disable();
      this.templatecreationmaster.get('templateType').disable();
      this.templatecreationmaster.get('templateFile').disable();
      this.templatecreationmaster.get('configFile').disable();
      this.templatecreationmaster.get('quickSightReference').disable();
      this.templatecreationmaster.get('parentTemplateId').reset();
      this.templatecreationmaster.get('binderSectionName').reset();
      this.templatecreationmaster.get('documentDocTypeLabel').reset();
      this.templatecreationmaster.get('documentDocSubTypeLabel').reset();
      this.templatecreationmaster.get('documentDocClassificationLabel').reset();
      this.templatecreationmaster.get('documentDocLifecycle').reset();
      this.templatecreationmaster.get('templateType').reset();
      this.templatecreationmaster.get('templateFile').reset();
      this.templatecreationmaster.get('configFile').reset();
      this.templatecreationmaster.get('quickSightReference').reset();
 
       
      this.templateCreationData.templateFile = null;
    } else {
      /**
       * Modified By Ashwin M
       * 25/08/2025
       * code modified to enable and/or disable required fields based on reportTypeName
      */
     //disable and reset all the dropdown and textbox which are for SA and SR
     this.templatecreationmaster.get('vaultBinderTemplate').disable();
     this.templatecreationmaster.get('mergeReports').disable();
     this.templatecreationmaster.get('binderType').disable();
     this.templatecreationmaster.get('quickSightReference').disable();

     this.templatecreationmaster.get('datasetId').enable();
     this.templatecreationmaster.get('selectfilter').enable();
     this.templatecreationmaster.get('templateType').enable();
     this.templatecreationmaster.get('templateFile').enable();
     
     if (this.pushToVault && ((this.reportTypeName == 'SR' && this.parentTemplateType == 'vault') || this.reportTypeName == 'SA')){
      console.log(this.parentTemplateType);
      this.templatecreationmaster.get('documentDocTypeLabel').enable();
      this.templatecreationmaster.get('documentDocSubTypeLabel').enable();
      this.templatecreationmaster.get('documentDocClassificationLabel').enable();
      this.templatecreationmaster.get('documentDocLifecycle').enable();
     } else {
      this.templatecreationmaster.get('documentDocTypeLabel').disable();
      this.templatecreationmaster.get('documentDocSubTypeLabel').disable();
      this.templatecreationmaster.get('documentDocClassificationLabel').disable();
      this.templatecreationmaster.get('documentDocLifecycle').disable();
     }
     
     this.templatecreationmaster.get('vaultBinderTemplate').reset();
     this.templatecreationmaster.get('datasetId').reset();
    //  this.templatecreationmaster.get('selectfilter').reset();
     this.templatecreationmaster.get('documentDocTypeLabel').reset();
     this.templatecreationmaster.get('documentDocSubTypeLabel').reset();
     this.templatecreationmaster.get('documentDocClassificationLabel').reset();
     this.templatecreationmaster.get('documentDocLifecycle').reset();
     this.templatecreationmaster.get('templateType').reset();
     this.templatecreationmaster.get('templateFile').reset();
     this.templatecreationmaster.get('quickSightReference').reset();
     this.templatecreationmaster.get('binderType').reset();
     this.templatecreationmaster.get('mergeReports').reset();
     this.templateCreationData.templateFile = null;
     this.templatecreationmaster.get('templateType').enable();
     this.templatecreationmaster.get('templateType').reset();
     this.templateTypeName = '';
     this.templateCreationData.binderDocType = null;
     this.templateCreationData.binderDocSubType = null;
     this.templateCreationData.binderDocClassification = null;

     if (this.reportTypeName == 'SR') {
      this.templatecreationmaster.get('parentTemplateId').enable();
      this.templatecreationmaster.get('binderSectionName').enable();
      if (this.templateCreationData.parentTemplateId == undefined || this.templateCreationData.parentTemplateId == null){
        this.templatecreationmaster.get('parentTemplateId').reset();
      }
      this.templatecreationmaster.get('binderSectionName').reset();
      // this.service.retrieveVaultBinderTemplateSections(dnsId,)
      this.spinner.start();
      //downloading parentTemplate if response is not null fetching section from on its fields vaultbindertemplate
      this.commonService.getParentReportTemplateDetails().subscribe(response => {
        console.log(response);
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
        } else {
          this.spinner.stop();
          console.log(response);
          this.parentTemplateDropDown = response;
          console.log(this.templateCreationData.parentTemplateId);
          if (this.templateCreationData.parentTemplateId > 0) {
            console.log(this.templateCreationData.parentTemplateId);
            this.parentTemplateDropDown.forEach(response => {
              if (response.reportTemplateId == this.templateCreationData.parentTemplateId) {
                this.templateCreationData.binderDocType = response['docType']
                this.templateCreationData.binderDocSubType = response['docSubType']
                this.templateCreationData.binderDocClassification = response['docClassification']
                this.templateCreationData.vaultBinderTemplate = response['vaultBinderTemplate']
                console.log(this.templateCreationData)
                console.log(this.templateCreationData.parentTemplateId);
                console.log(response);
                if (response.binderType == 'vault'){
                  this.service.retrieveVaultBinderTemplateSections(this.templateCreationData.dnsId, this.templateCreationData.vaultBinderTemplate).subscribe(response => {
                    if (response.error == true) {
                      this.spinner.stop();
                      this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});  
                    } else {
                      this.spinner.stop();
                      this.selectionDropDown = response;
                    }
                  });
                }
              }
            });
          }
        }
      });
     } else {
      /**
       * Modified By Ashwin M
       * 25/08/2025
       * code modified to disable parentTemplateId and binderSectionName for standalone report
      */
      this.templatecreationmaster.get('parentTemplateId').disable();
      this.templatecreationmaster.get('binderSectionName').disable();
      this.templatecreationmaster.get('parentTemplateId').reset();
      this.templatecreationmaster.get('binderSectionName').reset();
     }

   }
   if (this.docType == undefined) {
     this.showCliassification = false;
     this.docSubTypeShow = false;
   }
   
  }

  isRoleIdPresent(datasetRolesIds, responseRolesId) {
    // Split the datasetRolesIds string into an array based on commas
    if  (datasetRolesIds != null ){
    let roleIdsArray = datasetRolesIds.split(',');

    // Loop through the array of role IDs
    for (let j = 0; j < roleIdsArray.length; j++) {
      // Trim any extra spaces around role IDs and compare with responseRolesId
      console.log(roleIdsArray[j].trim()+"-------"+responseRolesId)
      if (roleIdsArray[j].trim() == responseRolesId) {
          console.log("Match found for Role ID: " + roleIdsArray[j]);
          return true; // Role ID found
      }
    }
    }
    return false; // Role ID not found
  }

  docType;
  documentDocTypeLabelSelect(value: any) : any {
    this.spinner.start();
    console.log(value);
   this.docTypeDropDown.forEach(res=>{
     if(res.docTypeLabel == value){
       this.docType = res.docType
     }
   })
    this.service.retrieveVaultDocumentSubTypes(this.docType).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
        this.templateCreationData.documentDocSubTypeLabel = null;
        this.templateCreationData.documentDocClassificationLabel = null;
        return this.docSubTypeDropDown = null
        

      } else {
 
        this.spinner.stop();
        this.docSubTypeDropDown = response
        
        this.docClassificationDropDown = null;
        this.showCliassification = false;

        
        this.templateCreationData.documentDocSubTypeLabel = null;
        this.templateCreationData.docLifecycle = null;
        this.templateCreationData.documentDocClassificationLabel = null;
        //this.docClassificationValues.docClassificationLabel
        this.docLifecycleDropdown = this.docSubTypeDropDown.filter(a => a.docLifecycle != null);
        this.docSubTypeDropDown = this.docSubTypeDropDown.filter(a => a.docSubType != null);
        console.log(this.docSubTypeDropDown)
        if (this.docSubTypeDropDown.length > 0) {
          this.docSubTypeShow = true;
          this.templatecreationmaster.get('documentDocSubTypeLabel').setValidators([Validators.required]);

        } else {
          this.docSubTypeShow = false;
        }

        return this.docSubTypeDropDown

      }
    });
  }
  docSubType
  documentDocSubTypeLabelSelect(value) {
    console.log(value);
    this.spinner.start();
    this.docSubTypeDropDown.forEach(res=>{
      if(res.docSubTypeLabel == value){
        this.docSubType = res.docSubType
      }
    })
    console.log();
    this.service.retrieveVaultDocumentClassifications(this.docType,this.docSubType).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
        this.docLifecycleDropdown = null;
        return this.docClassificationDropDown = null
       

      } else {

        this.spinner.stop();
        
        this.docClassificationDropDown = response;
        console.log(this.docClassificationDropDown)
        console.log(this.docClassificationDropDown.length)
        this.docLifecycleDropdown = this.docClassificationDropDown.filter(a => a.docLifecycle != null);
        this.docClassificationDropDown = this.docClassificationDropDown.filter(a => a.docClassification != null);
        console.log(this.docLifecycleDropdown);
        console.log(this.docClassificationDropDown);

        if (this.docClassificationDropDown.length > 0) {
          this.showCliassification = true;
          this.templatecreationmaster.get('documentDocClassificationLabel').setValidators([Validators.required]);
        } else {
          this.showCliassification = false;
        }
        this.templateCreationData.documentDocClassificationLabel = null;
        return this.docClassificationDropDown;


      }
    });

  }

  docClassification;
  documentLifeCycleForClassification(value) {
    console.log(value);
    this.spinner.start();
    this.docClassificationDropDown.forEach(res => {
      if (res.docClassificationLabel == value) {
        this.docClassification = res.docClassification;
      }
    })
    console.log(this.docType,this.docSubType,value,"===============")
    console.log();
    this.service.retrieveVaultDocumentLifeCycleForClassifications(this.docType, this.docSubType, this.docClassification).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
        return this.docLifecycleDropdown = null

      } else {

        this.spinner.stop();

        this.docLifecycleDropdown = response;
        console.log(this.docLifecycleDropdown)
        console.log(this.docLifecycleDropdown.length)
        // if (this.docClassificationDropDown.length > 0) {
        //   this.showCliassification = true;
        // } else {
        //   this.showCliassification = false;
        // }
        return this.docLifecycleDropdown;


      }
    });

  }
 

  downloadTemplate(event){
    this.spinner.start();
    console.log(this.templateCreationData.datasetId)
    if(this.templateCreationData.datasetId != undefined && this.templateCreationData.datasetId != null){
      let datasetDetails: any;
      this.reportingService.retrieveDatasetDetails(this.templateCreationData.datasetId).subscribe(response=>{
        console.log(response);
        datasetDetails = response;
        console.log(datasetDetails);
        if (datasetDetails.templateS3Path === null || datasetDetails.templateS3Path === undefined){
          this.snackbar.open("Template does not exists", "OK", {"duration": 5000});
        }else{
          let fileName = datasetDetails.templateS3Path.substring(datasetDetails.templateS3Path.lastIndexOf("/") + 1);
          this.reportingService.downloadDatasetTemplate(this.templateCreationData.datasetId,"excelTemplate").subscribe(response=>{
            var dataBlob = new Blob([response]);
            const fileData = window.URL.createObjectURL(dataBlob);
            let link = document.createElement('a');
            link.href = fileData;
            link.download = fileName;
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(fileData);
              link.remove();
            }, 100);
          })
        }
      });
    }
    this.spinner.stop();
  }
  async retrieveDataSourceSingleRecord(dnsId){
    this.getDataSourceDetails = await this.commonService.retrieveSingleRecordService('vaultconfigmstr','vaultconfigmstrid',dnsId);
    console.log(this.getDataSourceDetails);
    if(this.getDataSourceDetails[0].reportsTargetVault == null){
      this.pushToVault=false;
      /**
       * Modified By Ashwin M
       * 25/08/2025
       * code modified to update parentTemplateType to s3 when target vault is not configured
      */
      this.parentTemplateType = 's3';
      if (this.reportTypeName == 'RB' && this.templateCreationData.binderType == 'vault'){
        this.templatecreationmaster.controls['binderType'].setValue(null);
        this.snackbar.open("Please configure Target vault to create vault binder", 'OK', {duration: 5000})
      }
    }else{
      this.pushToVault=true;
    }
    console.log(this.pushToVault);
  }
 async retriveManageFilters(datasetid:any){
  this.filterstable=await this.reportService.retrieveFiltermanagebyDataSetid(datasetid);
 }
 bindSelectFilter(scheduleFilter){

  this.selectfilter=scheduleFilter;
console.log( scheduleFilter)
}
async binderTypeSelection(value: any){
  /**
   * Modified By Ashwin M
   * 25/08/2025
   * code standardized to remove duplication
  */
  console.log("Binder Type:", value)
    this.templateCreationData.binderType = value;
    this.spinner.start();
    this.retrieveDataSourceSingleRecord(this.templateCreationData.dnsId);
    this.reteriveDataOnReportType();
    this.spinner.stop();
  }

  editDataUpdate(){
    if (this.data.edata){
      if (this.reportTypeName == 'RB'){
        console.log(this.templateCreationData.binderType);
        this.binderTypeSelection(this.templateCreationData.binderType);
        this.reteriveDataOnReportType();
      } else if (this.reportTypeName == 'SR'){
        this.reteriveDataOnReportType();
        this.templatecreationmaster.controls['parentTemplateId'].setValue(this.data.edata.reportType);
        this.selectParentTemplate(this.data.edata.parentTemplateId);
      } else{
        this.pushToVault = false;
         
        this.reteriveDataOnReportType();
        
      }
    }
  }
}
